module.exports = __webpack_public_path__ + "static/media/camera-movie.6538eed5.svg";